import React from "react";
import styled from "styled-components";
import { map, filter, flatten } from "lodash";

import { tableStyle, tableLabelStyle } from "./styles";
import { moneyFormatM } from "./format";

const InfoTooltip = styled.span`
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  padding: 8px 12px;
  border-radius: 6px;
  background: rgba(0, 27, 59, 0.94);
  color: #FFFFFF;
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: 0;
  text-transform: none;
  width: 260px;
  text-align: center;
  opacity: 0;
  pointer-events: none;
  transition: opacity 100ms ease;
  z-index: 10;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 5px solid transparent;
    border-top-color: rgba(0, 27, 59, 0.94);
  }
`;

const InfoIcon = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 1px solid rgba(0, 27, 59, 0.4);
  color: rgba(0, 27, 59, 0.6);
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  cursor: help;
  margin-left: 6px;
  vertical-align: middle;

  &:hover ${InfoTooltip} {
    opacity: 1;
  }
`;

export const populateKeys = (groups, values) =>
  map(groups, group => ({
    ...group,
    rows: filter(
      map(group.rows, el => ({
        ...el,
        value: el.fn ? el.fn(values) : values[el.key || el.label]
      })),
      ({ value }, index, rows) => value !== 0 || index === rows.length - 1
    )
  }));

const formatSpecific = (value, label) => {
  if (label === "Holding Expenses" && value >= -1 && value <= 1) {
    return value < 0 ? "-$0.000 M" : "$0.000 M";
  }

  const shortValue = Math.abs(Number((value / 1e6).toFixed(3)));
  if (shortValue === 0) {
    return value < 0 ? "-$0.000 M" : "$0.000 M";
  }

  return moneyFormatM(value);
};

const MoneyTable = ({ keys }) => (
  <table style={tableStyle}>
    <tbody>
      {flatten(
        map(keys, ({ group, rows }) =>
          map(rows, ({ label, key, value, withoutValue, tooltip }, index) => [
            <tr
              style={{
                height: "2.2em"
              }}
              key={label}
            >
              {index === 0 ? (
                <td rowSpan={rows.length} style={tableLabelStyle}>
                  {group}
                </td>
              ) : null}
              <td
                style={{
                  width: "100%",
                  paddingRight: "2ch",
                  borderRadius: "1.1em 0 0 1.1em",
                  ...(index === rows.length - 1
                    ? { backgroundColor: "#8DD9DE" }
                    : {}),
                  textDecoration: withoutValue ? "underline" : "none",
                  paddingTop: withoutValue ? "15px" : "0",
                  paddingBottom: withoutValue ? "5px" : "0",
                }}
              >
                {label}
                {tooltip && (
                  <InfoIcon>
                    ?
                    <InfoTooltip>{tooltip}</InfoTooltip>
                  </InfoIcon>
                )}
              </td>
              {
                !withoutValue &&
                <td
                  style={{
                    textAlign: "center",
                    color: value < 0 ? "#FF0000" : "#3A3A3A",
                    fontSize: "16px",
                    paddingRight: "1ch",
                    ...(index === rows.length - 1
                      ? { backgroundColor: "#8DD9DE", fontWeight: "bold" }
                      : { fontWeight: "normal" })
                  }}
                >
                  {formatSpecific(value, label)}
                </td>
              }
            </tr>,
            index === rows.length - 1 ? (
              <tr style={{ height: "1em" }}>
                <td />
                <td />
                <td />
              </tr>
            ) : null
          ])
        )
      )}
    </tbody>
  </table>
);

export default MoneyTable;



// WEBPACK FOOTER //
// ./src/components/analysis/MoneyTable.js